import { deleteToken, getToken, isSupported, onMessage } from 'firebase/messaging';
import { Timestamp } from 'firebase/firestore';
import { createPushClient, firebaseMessagingAdapter, firestoreTokenStore } from '@kilat/ui';

import { messaging } from '../firebase.js';
import { env } from '../env.js';
import { logger } from '../logger.js';
import { fcmTokensRepoFor } from '../repositories/fcm-tokens-repo.js';

/**
 * Operator push client. The dashboard IS a PWA (vite-plugin-pwa, sw.js at the
 * root), and FCM's worker registers separately at /firebase-messaging-sw.js
 * under the push-only scope, so it never competes with the app shell worker.
 * Works in an ordinary desktop browser tab too — Web Push does not need the
 * app to be installed, except on iOS.
 *
 * No React: use-auth.tsx calls `cleanupForSignOut` before switching users.
 */
export const dashboardPushClient = createPushClient({
  messaging: firebaseMessagingAdapter(
    { isSupported, getToken, deleteToken, onMessage },
    messaging,
    env.fcmVapidKey,
  ),
  tokens: firestoreTokenStore({
    repoFor: fcmTokensRepoFor,
    now: () => Timestamp.now(),
    fromParts: (seconds, nanoseconds) => new Timestamp(seconds, nanoseconds),
  }),
  logger,
  vapidKeyPresent: Boolean(env.fcmVapidKey),
  appBase: '/',
});
